import { zql } from '../../schema.js';
import { getDrugRoundingMode } from '../../util/calculations/patient-drug-total-amount.js';
/** Dose rounding mode per drug catalog item id, so totals are saved with the rounding the prescription pop-up shows. */
export async function loadSubstanceRoundingModes(tx, substanceIds) {
    const ids = [...new Set(substanceIds.filter((id) => Boolean(id)))];
    if (ids.length === 0)
        return new Map();
    const drugs = await tx.run(zql.drugCatalogItems.where('id', 'IN', ids).related('activeSubstanceDetails').related('supportiveMedicationDetails'));
    return new Map(drugs.map(drug => [drug.id, getDrugRoundingMode(drug)]));
}
//# sourceMappingURL=substance-rounding-modes.js.map